// extracted by mini-css-extract-plugin
export var auto = "_3d-1";
export var spinner = "_3d-0";